/**
 * @desc: - 投注选号 - 大小单双
 * @param  {[STRING]} className：   [顶层 class]
 * @param  {[ARRAY]} items:         [选项]
 * @param  {[STRING]} values:       [当前选中值 ]
 * @param  {[FUNCTION]} onChange:   [变更时候的方法]
 * @author: ammo
 */
export default class BetBox extends React.Component {

	constructor(props) {
		super(props);
    this.makeDisplay = this.makeDisplay.bind(this)
	}

	// 点击
	handleClick(selectValue){
    const {items, values, onChange, index} = this.props;
    const arrayList = items;
    let result = null;
    switch (selectValue){
      // 全选
      case 'all': {
        result = _.map(arrayList, 'code');
        break;
      }
      // 清空
      case 'clear': {
        result = [];
        break;
      }
    }
    // 点击选择区
    if (!result) {
      // 已选
      if(selectValue.checked){
        result = _.remove(values, function(n){
          return n != selectValue.code
        })
      }else{
        // 没有选
        result = _.sortBy(_.concat(values, selectValue.code))
      }
    }
    onChange(result, index);
	}

	// 组装显示结果
	makeDisplay(items, values){
    const displayList = [];
    _.forEach(items, function(item){
      let eachItem = {
        display: _.replace(item.display, '|', '<br />'),
        checked: _.includes(values, item.code),
        code: item.code,
        className: _.split(item.display, '|').length > 1 ? 'nList sp sp2' : 'nList sp'
      }
      displayList.push(eachItem);
    })
    return displayList
	}

	render() {
		const {className, title, items, values, showButton} = this.props;
    const displayList = this.makeDisplay(items, values);
		return (
			<div className="each_k8">
        {
          title ? <h4>{title}</h4> : null
        }
				<ul className={displayList[0].className}>
					{
						displayList.map((item, index) => {
							return <li 
                      key={index} 
                      onClick={this.handleClick.bind(this, item)} 
                      className={item.checked ? 'hover' : ''} 
                      dangerouslySetInnerHTML={{__html: item.display}} 
                      ></li>
						})
					}
				</ul>
        <ul className='cList'>
          <li onClick={this.handleClick.bind(this, 'all')} >全</li>
          <li onClick={this.handleClick.bind(this, 'clear')} >清</li>
        </ul>
			</div>
		);
	}
}
